module.exports = __webpack_public_path__ + "static/media/Roboto-Bold.d329cc8b.ttf";